import styled, { css } from 'styled-components'
import leftIcon from '../../assets/icons/chevron-right.svg'

type props = {
  colorText: 'white' | 'black'
}

export const Container = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    cursor: pointer;
    padding-bottom: 5px;
    border-bottom: 1px solid #080520;

    position: fixed;
    top: 0;
    left: 0;
    background: white;
    min-width: 100vw;
  `}
`

export const IconBack = styled.img.attrs({
  src: leftIcon,
  alt: 'Voltar'
})`
  ${({ theme }) => css`
    width: 12px;  // ajuste conforme necessário
    height: 12px;  // ajuste conforme necessário
    margin-right: ${theme.spacing.stack.small};
    margin-left: 5%;
    transform: rotate(180deg);
  `}
`

export const Title = styled.p<props>`
  ${({ theme }) => css`
    font-weight: ${theme.font.weight.semiBold};
    font-size: ${theme.font.size.sm};
  `}

  ${(props) =>
    props.colorText === 'black'
      ? css`
          color: ${({ theme }) => theme.color.base.nth1};
        `
      : css`
          color: #FFFFFF;
        `}
`
